<div *ngIf="!isObjectEmpty(dataset); else noDataTemplate">
  <div
    id="chart-container"
    class="w-100"
    *ngIf="!isObjectEmpty(dataset); else noDataTemplate"
  >
    <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
  </div>

  <div class="pagination-controls">
    <button
      pButton
      class="pagination-btn"
      icon="pi pi-chevron-left"
      (click)="prevPage()"
      [disabled]="currentPage === 0"
    ></button>
    <span class="text-spn">Page {{ pageNumber }}</span>
    <button
      pButton
      class="pagination-btn"
      icon="pi pi-chevron-right"
      (click)="nextPage()"
      [disabled]="(currentPage + 1) * pageSize >= labels.length"
    ></button>
  </div>
</div>
<ng-template #noDataTemplate>
  <app-no-data></app-no-data>
</ng-template>
